import { ReactElement } from 'react';
import { Stack, Typography, Tooltip, Zoom, Divider } from '@mui/material';
import {
  HelpRounded as HelpIcon,
  WarningRounded as WarningIcon,
} from '@mui/icons-material';

import DashboardVariantV2CarrierHeaderExpandMore from '../ExpandMore';

import { DashboardVariantV2CarrierStatusInfoWidgetCardProps } from './types';
import {
  DashboardVariantV2CarrierStatusInfoWidgetCardContainer,
  DashboardVariantV2CarrierStatusInfoWidgetCardTypographyCurrent,
  DashboardVariantV2CarrierStatusInfoWidgetCardTypographyTotal,
  DashboardVariantV2CarrierStatusInfoWidgetCardIconImg,
  DashboardVariantV2CarrierStatusInfoWidgetCardButtonIcon,
} from './styles';

const DashboardVariantV2CarrierStatusInfoWidgetCard = ({
  value,
  icon,
  title,
  alert,
  accentColor = '#000000de',
  isSelected = false,
  onSelected,
  content,
  footer,
}: DashboardVariantV2CarrierStatusInfoWidgetCardProps): ReactElement => (
  <DashboardVariantV2CarrierStatusInfoWidgetCardContainer
    accentColor={accentColor}
    isSelected={isSelected}
    onClick={onSelected}
  >
    <Stack minHeight={90} justifyContent="space-between">
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-end"
      >
        <Stack spacing={1} direction="row" alignItems="center">
          <DashboardVariantV2CarrierStatusInfoWidgetCardTypographyCurrent
            color={accentColor}
          >
            {value.current}
          </DashboardVariantV2CarrierStatusInfoWidgetCardTypographyCurrent>

          <DashboardVariantV2CarrierStatusInfoWidgetCardTypographyTotal color="action.disabled">
            / {value.total}
          </DashboardVariantV2CarrierStatusInfoWidgetCardTypographyTotal>
        </Stack>

        <DashboardVariantV2CarrierStatusInfoWidgetCardIconImg {...icon} />
      </Stack>

      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-end"
      >
        <Stack spacing={1} direction="row">
          <Typography component="h6" variant="body1" fontWeight="bold">
            {title.text}
          </Typography>

          {title.tooltip && (
            <Tooltip title={title.tooltip} arrow placement="right">
              <HelpIcon color="disabled" sx={{ fontSize: 22 }} />
            </Tooltip>
          )}
        </Stack>

        {alert && (
          <Zoom in={alert.show} unmountOnExit>
            <Tooltip title={alert.tooltip} arrow placement="left">
              <DashboardVariantV2CarrierStatusInfoWidgetCardButtonIcon
                onClick={alert.onClick}
              >
                <WarningIcon color={alert.severity} fontSize="inherit" />
              </DashboardVariantV2CarrierStatusInfoWidgetCardButtonIcon>
            </Tooltip>
          </Zoom>
        )}
      </Stack>
    </Stack>

    <DashboardVariantV2CarrierHeaderExpandMore.Collapse>
      <Stack
        spacing={1}
        marginTop={1}
        minHeight={109}
        justifyContent="space-between"
      >
        <Stack spacing={1}>
          <Divider />

          {content}
        </Stack>

        {footer}
      </Stack>
    </DashboardVariantV2CarrierHeaderExpandMore.Collapse>
  </DashboardVariantV2CarrierStatusInfoWidgetCardContainer>
);

export default DashboardVariantV2CarrierStatusInfoWidgetCard;
